import { useEffect, useState } from "react";
import { userManager } from "./authClient";

export function AuthCallback() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    userManager
      .signinRedirectCallback()
      .then(() => {
        window.location.replace("/");
      })
      .catch((e) => setError(String(e)));
  }, []);

  if (error) {
    return (
      <div className="flex h-full items-center justify-center bg-slate-50 px-4">
        <div className="w-full max-w-md rounded-xl border border-red-100 bg-white p-6 shadow-soft">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-tvs-red/10 text-tvs-red">!</span>
            <h2 className="text-base font-semibold text-slate-900">No pudimos completar el login</h2>
          </div>
          <p className="mt-3 break-words text-sm text-slate-600">{error}</p>
          <button
            type="button"
            onClick={() => window.location.replace("/")}
            className="mt-5 w-full rounded-lg bg-tvs-blue px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-tvs-blue-dark"
          >
            Volver al inicio
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="flex h-full items-center justify-center bg-slate-50">
      <div className="flex items-center gap-3 text-sm text-slate-500">
        <span className="h-2 w-2 animate-pulse rounded-full bg-tvs-red" />
        Procesando login…
      </div>
    </div>
  );
}
